import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AvatarComponent } from "app/shared/avatar/avatar.component";
import { IconComponent } from "app/shared/icon/icon.component";
import { FriendsService } from "../service/friends.service";
import { IRequest } from "../model/friends.model";
import { MatButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { provideIcons } from "@ng-icons/core";
import { heroEllipsisHorizontal } from "@ng-icons/heroicons/outline";

@Component({
  selector: 'app-request-card',
  imports: [
    AvatarComponent,
    IconComponent,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
  ],
  templateUrl: './request-card.component.html',
  styleUrls: ['./request-card.component.scss'],
  providers: [
    provideIcons({
      heroEllipsisHorizontal,
    }),
  ],
})
export class RequestCardComponent {
  @Input() request!: IRequest;
  @Output() eventTriggered = new EventEmitter();

  friendsService = inject(FriendsService);

  onMenuClick(event: Event): void {
    event.stopPropagation();
  }

  shareTo(event: Event, userId: number) {
    event.stopPropagation();

    this.friendsService.shareTo(userId.toString()).subscribe(() => {
      this.eventTriggered.emit(userId);
    });
  }

  removeRequest(event: Event, userId: number) {
    event.stopPropagation();

    this.friendsService.removeFromFriends(userId.toString()).subscribe(() => {
      this.eventTriggered.emit(userId);
    });
  }
}
